import { Tab, TabList } from '@creditflowresearch/uilib/Tabs';
import { CountLabel } from '@creditflowresearch/uilib/Badge/CountLabel';

import styles from '@/creditflowresearch/ui/components/bondscreener/bondscreener.module.scss';

const LABEL_COLOR_COUNT = '#4A76B6';

export interface IBondScreenerTabConfig {
  id: string,
  name: string,
  badge?: number,
}

interface IBondScreenerTabBarProps {
  dataTest: string,
  tabs: IBondScreenerTabConfig[],
  activeTabId: string,
  onTabChange: (tabId: string) => void,
}

const BondScreenerTabBar = ({ dataTest, tabs, activeTabId, onTabChange }: IBondScreenerTabBarProps) => {
  return (
    <TabList dataTest={ dataTest }>
      { tabs.map((tab) => (
        <Tab
          key={ tab.id }
          tabFor={ tab.id }
          selected={ tab.id === activeTabId }
          name={ `${ dataTest }-${ tab.id }` }
          onClick={ () => onTabChange(tab.id) }
        >
          <span>{ tab.name }</span>
          { tab.badge !== undefined && (
            <CountLabel
              className={ styles.countLabel }
              canShowCount
              showCountWithZeroVolume={ false }
              maxTotalCount={ 99 }
              backgroundColor={ LABEL_COLOR_COUNT }
              totalCount={ tab.badge }
            />
          ) }
        </Tab>
      )) }
    </TabList>
  );
};

export default BondScreenerTabBar;
